"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9150],{

/***/ 9150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ frontend_CartStorage; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(9363);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9955);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(2186);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.7_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7039);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ./services/ObjectsInitialValues.js
var initialCart = {
  products: [],
  shippingFee: 0,
  shippingFeeCap: 0
};
;// CONCATENATED MODULE: ./services/frontend/StorageKeys.js
var CART_KEY = "CART_KEYS_2";
var PRODUCT_KEY = "product";
var STORE_KEY = "store";
var BAG_KEY = "BAG_KEY";

;// CONCATENATED MODULE: ./services/frontend/CartStorage.js



var _excluded = ["id"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var DB_NAME = "dm2buyDB";
var DB_VERSION = 1;
var STORE_NAME = "cartStore";
var CartStorage_CART_KEY = "cart"; // Checks if localStorage exists and is accessible/writable

function isLocalStorageAvailable() {
  try {
    // Check if window and localStorage are defined
    if ( false || typeof window.localStorage === "undefined") {
      // console.warn("LocalStorage is not defined.");
      return false;
    } // Try to use localStorage to catch security errors


    var testKey = "__cart_storage_test__";
    window.localStorage.setItem(testKey, testKey);
    window.localStorage.removeItem(testKey);
    return true;
  } catch (e) {
    // SecurityError or other exceptions mean it's not available/accessible
    console.warn("LocalStorage is not available or accessible: ".concat(e.message));
    return false;
  }
} // --- IndexedDB Helpers ---


function openDB() {
  return new Promise(function (resolve, reject) {
    if ( false || !window.indexedDB) {
      console.warn("IndexedDB not supported.");
      return reject("IndexedDB not supported");
    }

    var request = window.indexedDB.open(DB_NAME, DB_VERSION);

    request.onerror = function (event) {
      console.error("IndexedDB error:", event.target.error);
      reject("IndexedDB error: " + event.target.error);
    };

    request.onsuccess = function (event) {
      resolve(event.target.result);
    };

    request.onupgradeneeded = function (event) {
      var db = event.target.result;

      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, {
          keyPath: "id"
        });
        console.log("IndexedDB object store created.");
      }
    };
  });
}

function saveToIndexedDB(_x) {
  return _saveToIndexedDB.apply(this, arguments);
}

function _saveToIndexedDB() {
  _saveToIndexedDB = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(cartData) {
    var db, transaction, store, dataToStore, request;
    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return openDB();

          case 3:
            db = _context4.sent;
            transaction = db.transaction([STORE_NAME], "readwrite");
            store = transaction.objectStore(STORE_NAME); // Use a fixed key for the cart data

            dataToStore = _objectSpread({
              id: CartStorage_CART_KEY
            }, cartData);
            request = store.put(dataToStore);
            return _context4.abrupt("return", new Promise(function (resolve, reject) {
              request.onsuccess = function () {
                console.log("Cart saved to IndexedDB");
                resolve(true);
              };

              request.onerror = function (event) {
                console.error("Error saving cart to IndexedDB:", event.target.error);
                reject(event.target.error);
              };

              transaction.oncomplete = function () {
                db.close();
              };

              transaction.onerror = function (event) {
                console.error("IndexedDB transaction error:", event.target.error);
                db.close();
                reject(event.target.error);
              };
            }));

          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4["catch"](0);
            console.error("Failed to open DB for saving:", _context4.t0);
            if (db) db.close();
            return _context4.abrupt("return", Promise.reject(_context4.t0));

          case 16:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 11]]);
  }));
  return _saveToIndexedDB.apply(this, arguments);
}

function getFromIndexedDB() {
  return _getFromIndexedDB.apply(this, arguments);
}

function _getFromIndexedDB() {
  _getFromIndexedDB = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5() {
    var db, transaction, store, request;
    return regenerator_default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return openDB();

          case 3:
            db = _context5.sent;
            transaction = db.transaction([STORE_NAME], "readonly");
            store = transaction.objectStore(STORE_NAME);
            request = store.get(CartStorage_CART_KEY); // Use the fixed key

            return _context5.abrupt("return", new Promise(function (resolve, reject) {
              request.onsuccess = function (event) {
                var result = event.target.result;

                if (result) {
                  // console.log("Cart retrieved from IndexedDB");
                  var id = result.id,
                      cartData = (0,objectWithoutProperties/* default */.Z)(result, _excluded); // Exclude the 'id' key


                  resolve(cartData);
                } else {
                  // console.log("No cart data found in IndexedDB");
                  resolve(null);
                }
              };

              request.onerror = function (event) {
                console.error("Error retrieving cart from IndexedDB:", event.target.error);
                reject(event.target.error);
              };

              transaction.oncomplete = function () {
                db.close();
              };

              transaction.onerror = function (event) {
                console.error("IndexedDB transaction error:", event.target.error);
                db.close();
                reject(event.target.error);
              };
            }));

          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](0);
            console.error("Failed to open DB for retrieval:", _context5.t0);
            if (db) db.close();
            return _context5.abrupt("return", Promise.resolve(null));

          case 15:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 10]]);
  }));
  return _getFromIndexedDB.apply(this, arguments);
}

function deleteFromIndexedDB() {
  return _deleteFromIndexedDB.apply(this, arguments);
} // --- LocalStorage Helpers ---


function _deleteFromIndexedDB() {
  _deleteFromIndexedDB = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6() {
    var db, transaction, store, request;
    return regenerator_default().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return openDB();

          case 3:
            db = _context6.sent;
            transaction = db.transaction([STORE_NAME], "readwrite");
            store = transaction.objectStore(STORE_NAME);
            request = store["delete"](CartStorage_CART_KEY); // Use the fixed key

            return _context6.abrupt("return", new Promise(function (resolve, reject) {
              request.onsuccess = function () {
                // console.log("Cart deleted from IndexedDB");
                resolve(true);
              };

              request.onerror = function (event) {
                console.error("Error deleting cart from IndexedDB:", event.target.error);
                reject(event.target.error);
              };

              transaction.oncomplete = function () {
                db.close();
              };

              transaction.onerror = function (event) {
                console.error("IndexedDB transaction error:", event.target.error);
                db.close();
                reject(event.target.error);
              };
            }));

          case 10:
            _context6.prev = 10;
            _context6.t0 = _context6["catch"](0);
            console.error("Failed to open DB for deletion:", _context6.t0);
            if (db) db.close();
            return _context6.abrupt("return", Promise.reject(_context6.t0));

          case 15:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 10]]);
  }));
  return _deleteFromIndexedDB.apply(this, arguments);
}

function saveToLocalStorage(cartData) {
  // Use the availability check function
  if (!isLocalStorageAvailable()) {
    // console.warn("Attempted to save to LocalStorage, but it's unavailable.");
    return false;
  }

  try {
    var cartString = JSON.stringify(cartData);
    window.localStorage.setItem(CartStorage_CART_KEY, cartString); // console.log("Cart saved to LocalStorage");

    return true;
  } catch (error) {
    // Catch errors during the stringify/setItem process itself
    console.error("Error during saveToLocalStorage operation:", error);

    if (error.name === "QuotaExceededError") {
      console.warn("LocalStorage quota exceeded. Clearing cart data from LocalStorage.");
      deleteFromLocalStorage(); // This is safe because it also checks availability
    }

    return false;
  }
}

function getFromLocalStorage() {
  // Use the availability check function
  if (!isLocalStorageAvailable()) {
    // console.warn("Attempted to get from LocalStorage, but it's unavailable.");
    return null;
  }

  try {
    var cartString = window.localStorage.getItem(CartStorage_CART_KEY);

    if (cartString) {
      // console.log("Cart retrieved from LocalStorage");
      return JSON.parse(cartString);
    } // console.log("No cart data found in LocalStorage");


    return null;
  } catch (error) {
    // Catch errors during the getItem/JSON.parse process itself
    console.error("Error during getFromLocalStorage operation:", error);
    deleteFromLocalStorage(); // Attempt to clear potentially corrupted item

    return null;
  }
}

function deleteFromLocalStorage() {
  // Use the availability check function
  if (!isLocalStorageAvailable()) {
    // console.warn("Attempted to delete from LocalStorage, but it's unavailable.");
    return; // Can't delete if not available
  }

  try {
    window.localStorage.removeItem(CartStorage_CART_KEY); // console.log("Cart deleted from LocalStorage");
  } catch (error) {
    // Catch errors during the removeItem process itself
    console.error("Error during deleteFromLocalStorage operation:", error);
  }
} // --- Cart Service ---


var memoryCart = null; // In-memory cache

var CartStorage = {
  initializeCart: function () {
    var _initializeCart = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var cart, migrationNeeded, legacyKeyUsed, legacyCart, legacyCartString;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!memoryCart) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", memoryCart);

            case 2:
              cart = null;
              migrationNeeded = false;
              legacyKeyUsed = false; // 1. Check IndexedDB (New Key)

              _context.prev = 5;
              _context.next = 8;
              return getFromIndexedDB();

            case 8:
              cart = _context.sent;

              if (!cart) {
                _context.next = 12;
                break;
              }

              memoryCart = cart; // console.log("Initialized cart from IndexedDB (New Key)");

              return _context.abrupt("return", memoryCart);

            case 12:
              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](5);
              console.warn("Failed to get cart from IndexedDB: ".concat(_context.t0.message));

            case 17:
              // 2. Check LocalStorage (New Key - as fallback if IDB failed before)
              if (!cart && isLocalStorageAvailable()) {
                try {
                  cart = getFromLocalStorage(); // Uses CART_KEY = "cart"

                  if (cart) {
                    memoryCart = cart; // console.log("Initialized cart from LocalStorage (New Key - Fallback)");

                    migrationNeeded = true; // Needs migration from LS (new key) to IDB
                    // Don't return yet, proceed to check legacy key just in case,
                    // but prioritize this one if legacy is also somehow present.
                  }
                } catch (error) {
                  console.warn("Error during LocalStorage (New Key) initialization attempt: ".concat(error.message));
                }
              } // 3. Check LocalStorage (Legacy Key - for old users)


              legacyCart = null;

              if (isLocalStorageAvailable()) {
                // Check LS availability again
                try {
                  legacyCartString = window.localStorage.getItem(CART_KEY);

                  if (legacyCartString) {
                    legacyCart = JSON.parse(legacyCartString); // console.log("Found cart data using Legacy Key");

                    if (!cart) {
                      // Only use legacy cart if no cart found under the new key
                      cart = legacyCart;
                      memoryCart = cart;
                      migrationNeeded = true; // Needs migration from LS (legacy key) to IDB

                      legacyKeyUsed = true; // console.log("Using cart from Legacy Key");
                    }
                  }
                } catch (error) {
                  console.warn("Error checking/parsing legacy cart key (".concat(CART_KEY, "): ").concat(error.message)); // Attempt to clear potentially corrupted legacy item

                  try {
                    window.localStorage.removeItem(CART_KEY);
                  } catch (e) {}
                }
              } // 4. Perform Migration if needed (either from LS fallback or legacy key)


              if (!(cart && migrationNeeded)) {
                _context.next = 30;
                break;
              }

              _context.prev = 21;
              _context.next = 24;
              return saveToIndexedDB(cart);

            case 24:
              // Save the found cart to IDB (uses new key "cart")
              // console.log("Migration to IndexedDB successful.");
              // If migration succeeded, clean up the source
              if (legacyKeyUsed && isLocalStorageAvailable()) {
                // console.log(`Removing legacy cart item (${LEGACY_CART_KEY}) after successful migration.`);
                try {
                  window.localStorage.removeItem(CART_KEY);
                } catch (e) {
                  console.warn("Failed to remove legacy cart key after migration: ".concat(e.message));
                }
              } else if (!legacyKeyUsed && isLocalStorageAvailable()) {
                // If we migrated from the new key fallback, remove it from LS
                // console.log(`Removing LS fallback item (${CART_KEY}) after successful migration.`);
                try {
                  window.localStorage.removeItem(CartStorage_CART_KEY);
                } catch (e) {
                  console.warn("Failed to remove LS fallback key after migration: ".concat(e.message));
                }
              }

              _context.next = 30;
              break;

            case 27:
              _context.prev = 27;
              _context.t1 = _context["catch"](21);
              console.warn("Failed to migrate cart to IndexedDB: ".concat(_context.t1.message)); // If migration fails, the data remains in memoryCart and potentially in LS source

            case 30:
              // 5. Set to initialCart if nothing found
              if (!cart) {
                // console.log("Initializing with empty cart (no persistent storage found).");
                memoryCart = initialCart;
              } // Make sure memoryCart is set if cart was found but migration logic didn't run/set it


              if (cart && !memoryCart) {
                memoryCart = cart;
              }

              return _context.abrupt("return", memoryCart);

            case 33:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 14], [21, 27]]);
    }));

    function initializeCart() {
      return _initializeCart.apply(this, arguments);
    }

    return initializeCart;
  }(),
  // Save cart state to memory and persistent storage
  saveCart: function () {
    var _saveCart = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(cartData) {
      var localStorageSuccess;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (cartData) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              memoryCart = _objectSpread({}, cartData); // Update in-memory cache first

              _context2.prev = 3;
              _context2.next = 6;
              return saveToIndexedDB(memoryCart);

            case 6:
              // Uses new key "cart"
              // If IndexedDB succeeds, try to remove from LocalStorage (if available)
              // This targets the fallback key ("cart"), not the legacy one.
              if (isLocalStorageAvailable()) {
                deleteFromLocalStorage(); // Uses new key "cart"
              } // console.log("Saved cart to IndexedDB (and attempted LS fallback cleanup)");


              _context2.next = 29;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](3);
              console.warn("Failed to save cart to IndexedDB, falling back to LocalStorage (if available): ".concat(_context2.t0.message)); // Try saving to LocalStorage only if it's available

              if (!isLocalStorageAvailable()) {
                _context2.next = 28;
                break;
              }

              localStorageSuccess = saveToLocalStorage(memoryCart); // Uses new key "cart"

              if (localStorageSuccess) {
                _context2.next = 18;
                break;
              }

              console.error("IndexedDB failed AND LocalStorage failed to save. Cart state might be lost on refresh.");
              _context2.next = 26;
              break;

            case 18:
              _context2.prev = 18;
              _context2.next = 21;
              return deleteFromIndexedDB();

            case 21:
              _context2.next = 26;
              break;

            case 23:
              _context2.prev = 23;
              _context2.t1 = _context2["catch"](18);
              console.warn("Failed to delete potentially inconsistent IndexedDB cart data after LS save: ".concat(_context2.t1.message));

            case 26:
              _context2.next = 29;
              break;

            case 28:
              // IndexedDB failed AND LocalStorage is unavailable
              console.error("IndexedDB failed and LocalStorage is unavailable. Cart state might be lost on refresh.");

            case 29:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 9], [18, 23]]);
    }));

    function saveCart(_x2) {
      return _saveCart.apply(this, arguments);
    }

    return saveCart;
  }(),
  // Get the current cart state (from memory)
  getCart: function getCart() {
    return memoryCart || initialCart; // Return memory cache or default
  },
  // Clear cart from memory and persistent storage
  clearCart: function () {
    var _clearCart = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              memoryCart = initialCart; // Clear memory cache

              _context3.prev = 1;
              _context3.next = 4;
              return deleteFromIndexedDB();

            case 4:
              _context3.next = 9;
              break;

            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](1);
              console.warn("Failed to delete cart from IndexedDB during clear: ".concat(_context3.t0.message));

            case 9:
              // Try clearing LocalStorage as well (if available)
              if (isLocalStorageAvailable()) {
                deleteFromLocalStorage(); // Uses new key "cart"
                // Also attempt to clear the legacy key, just in case

                try {
                  window.localStorage.removeItem(CART_KEY);
                } catch (e) {}
              } // console.log("Cleared cart from memory and attempted persistent storage clear.");


            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 6]]);
    }));

    function clearCart() {
      return _clearCart.apply(this, arguments);
    }

    return clearCart;
  }(),
  // Utility to get initial cart structure
  getInitialCart: function getInitialCart() {
    return initialCart;
  }
};
/* harmony default export */ var frontend_CartStorage = (CartStorage);

/***/ })

}]);